import React from "react";

export const equipmentStatusesOptions = [
  "RELEASE_AT_LATER_DATE",
  "READY_FOR_RELEASE",
  "RELEASED",
  "AT_SHOP",
  "LEAVING_SHOP",
  "DELIVERED",
];
// export const categoryOptions = [
export const toolsCategoryOptions = [
  "Power Tools",
  "Hand Tools",
  "Consumable Tools",
  "Large Power Tools",
  "Ladders",
  "Safety",
  "Gangbox",
];
export const equipmentsCategoryOptions = [
  "SHOP_INVENTORY",
  "RETURNED_TO_VENDOR",
  "RECYCLED",
  "THROWN_AWAY",
];
export const toolsStatusesOptions = ["CHECK_IN", "CHECK_OUT", "TRANSFER"];

export const equipmentShipLocationOptions = () => {
  return ["SITE", "SHOP", "CRANE_YARD", "OTHER"];
};
export const promiseNull = (err) => {
  if (!err.toString().includes("Missing or insufficient permissions.")) {
    console.log(err);
  }

  new Promise((res, rej) => res(null));
};
export const promiseError = (err) => {
 
  new Promise((res, rej) => res(err));
};

export const useScrollListener = (element, handleScroll) => {
  React.useEffect(() => {
    const currentElement = element.current;
    if (currentElement) {
      currentElement.addEventListener("scroll", handleScroll);
    }
    return () => {
      if (currentElement) {
        // return currentElement.removeEventListener("scroll", handleScroll)
      } else {
        // return null
      }
    };
  }, [element]);
};

export const getToolCategoryClasses = (selectedCategory) => {
  if (!selectedCategory) {
    return "";
  }
  let category = selectedCategory.replaceAll("_", " ").toLowerCase();
  if (category === "Power Tools".toLowerCase()) {
    return "category-power-tools";
  } else if (category === "Hand Tools".toLowerCase()) {
    return "category-hand-tools";
  } else if (category === "Consumable Tools".toLowerCase()) {
    return "category-consumable-tools";
  } else if (category === "Large Power Tools".toLowerCase()) {
    return "category-large-power-tools";
  } else if (category === "Ladders".toLowerCase()) {
    return "category-ladders-tools ";
  } else if (category === "Safety".toLowerCase()) {
    return "category-safety-tools";
  } else if (category === "Gangbox".toLowerCase()) {
    return "category-gangbox";
  } else {
    return "";
  }
};

const env = process.env.NODE_ENV;
const deploy_env = process.env.REACT_APP_DEPLOY_ENV;
export const BASE_API_URL =
  env === "production" && deploy_env === "prod"
    ? "https://us-central1-sitetrace-prod.cloudfunctions.net"
    : "https://us-central1-sitetrace-dev.cloudfunctions.net";
